import { createServices } from '@vs/vsf-boot';
export default createServices({
  OrderResearchLearningController_queryPagedByLearningOrderQto_482a08: {
    method: 'post',
    url: '/api/order-research-learning/query-paged-by-learning-order-qto',
    parameterFomatter: (data?: {
      qto: LearningOrderQtoOrderResearchLearningPersistQto;
      ext: any;
    }) => data,
    responseFormatter: (
      _,
      __,
      data?: {
        count: number;
        result: LearningOrderVoOrderResearchLearningEntranceWebVo[];
        from: number;
        size: number;
        scrollId: string;
        hasMore: boolean;
      },
    ) => data,
  },
});
